var _defs, _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.997,
    height: 26.997,
    viewBox: "0 0 26.997 26.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#2A7DE1;}.b{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.21,
    height: 12.21,
    rx: 6.105,
    transform: "translate(0 14.288)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-2151.895-2918.291a6.112,6.112,0,0,1-6.106-6.1,6.112,6.112,0,0,1,6.106-6.1,6.112,6.112,0,0,1,6.1,6.1A6.112,6.112,0,0,1-2151.895-2918.291Zm0-9.624a3.524,3.524,0,0,0-3.52,3.519,3.524,3.524,0,0,0,3.52,3.52,3.523,3.523,0,0,0,3.519-3.52A3.523,3.523,0,0,0-2151.895-2927.914Z",
    transform: "translate(2172.287 2944.788)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.21,
    height: 12.21,
    rx: 6.105,
    transform: "translate(14.287)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.21,
    height: 12.21,
    rx: 6.105
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessActive);
export default __webpack_public_path__ + "static/media/businessActive.c99241fd0791b5074677223725e0e913.svg";
export { ForwardRef as ReactComponent };